import { useEffect } from "react";

const BASE = "https://www.ecojard.pt";

export default function SEO({ title, description, path = "/" }) {
  useEffect(() => {
    document.title = title;
    const set = (sel, attr, val) => {
      const el = document.head.querySelector(sel);
      if (el) el.setAttribute(attr, val);
    };
    set('meta[name="description"]', "content", description);
    set('link[rel="canonical"]', "href", BASE + path);
    set('meta[property="og:title"]', "content", title);
    set('meta[property="og:description"]', "content", description);
    set('meta[property="og:url"]', "content", BASE + path);
  }, [title, description, path]);
  return null;
}
